<template>
  <div style="position: relative">
    <div v-if="loading" class="progress-bar">
      <div class="progress-bar-value"></div>
    </div>
    <div v-if="loading" class="loading-overlay"></div>
    <h3 class="d-flex align-items-center justify-content-between">
      <div class="align-items-center">
        <feather-icon size="22" icon="PackageIcon" />
        <span class="mx-50"> التصنيفات و الخدمات </span>
      </div>
      <b-tooltip
        placement="bottom"
        :disabled="!isClassificationAddDisabled"
        target="addClass"
        variant="info"
      >
        <span>{{ classificationTooltipText }}</span>
      </b-tooltip>
      <div id="addClass">
        <b-button
          v-can="{ slug: $route.meta.slug, action: 'C' }"
          :disabled="isClassificationAddDisabled"
          @click="newClassModal = true"
          variant="success"
          v-if="!ngoData.completed_by_ngo"
          >إضافة تصنيف
        </b-button>
      </div>
    </h3>
    <hr />
    <class-modal
      :loading="working"
      @confirm="saveClassification"
      v-model="newClassModal"
    />
    <class-modal
      :loading="working"
      @confirm="onUpdateClassification"
      ref="editClassModal"
      v-model="editClassModal"
      :intializeForm.sync="editClassForm"
    />
    <template v-if="servicesAndClassifications.length > 0">
      <div
        v-for="(classification, i) in servicesAndClassifications"
        :key="classification.id"
      >
        <div class="d-flex align-items-center justify-content-between">
          <h4 class="p-2 pb-3">
            {{ i + 1 }} :
            <span class="alert alert-primary pr-1 pl-1">{{
              classification.name_ar
            }}</span>
          </h4>
          <b-dropdown class="mx-1" variant="link" no-caret :right="true">
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-can="{ slug: $route.meta.slug, action: 'O' }"
              variant="success"
              @click="
                serviceModal = true;
                classId = classification.id;
              "
            >
              <feather-icon icon="PlusIcon" />
              <span class="align-middle ml-50">إضافة خدمة</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-can="{ slug: $route.meta.slug, action: 'D' }"
              variant="danger"
              @click="deleteClass(classification.id)"
              v-if="!ngoData.completed_by_ngo"
            >
              <feather-icon icon="Trash2Icon" />
              <span class="align-middle ml-50">حذف</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div>
          <b-row v-if="servicesAndClassifications[i].ngo_services.length > 0">
            <b-col
              v-for="service in servicesAndClassifications[i].ngo_services"
              :key="service.id"
              sm="12"
              md="6"
              xl="4"
            >
              <service-card
                @showUpdateModal="
                  showUpdateServiceModal(service, classification.id)
                "
                :id="service.id"
                :title="service.service.name_ar"
                :description="service.description"
                icon="EditIcon"
                :is_active="service.is_active"
                :status="service.status"
                :service="service.service"
                :service_frequency="service.service_frequency"
                :providing_date="service.providing_date"
                :resumption_date="service.resumption_date"
              />
            </b-col>
          </b-row>
          <div v-else class="text-center p-1" style="opacity: 0.8">
            <h5>
              <feather-icon class="mx-25" icon="AlertTriangleIcon" />

              لا يوجد لديك أي خدمات تحت هذا التصنيف
            </h5>
          </div>
        </div>
      </div>
    </template>
    <div v-else>
      <div class="text-center p-1" style="opacity: 0.6">
        <h5 class="text-warning">
          <feather-icon class="mx-25" icon="AlertTriangleIcon" />

          لا يوجد تصنيفات حتى الآن
        </h5>
      </div>
    </div>
    <service-modal
      @confirm="saveService($event)"
      :loading="working"
      :btnLabel="'حفظ'"
      v-model="serviceModal"
      ref="serviceModal"
      :classId.sync="classId"
    />

    <service-modal
      @confirm="saveService($event)"
      :loading="working"
      :btnLabel="'حفظ'"
      v-model="updateServiceModal"
      ref="updateServiceModal"
      :classId.sync="classId"
      :intializeForm.sync="editForm"
    />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormRadio,
  BForm,
  BFormTextarea,
  BDropdown,
  BDropdownItem,
  BFormDatepicker,
  BButton,
  VBTooltip,
  BTooltip,
} from "bootstrap-vue";
import formSelect from "@/components/form-select";
import saveBtn from "@/components/loader-btn";
import formDatepicker from "@/components/form-datepicker";
import ngoMap from "@/components/ngo-map";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import serviceCard from "../../components/ServiceCard.vue";
import ServiceModal from "../../components/ServiceModal.vue";
import ClassModal from "../../components/ClassModal.vue";

import { mapActions, mapGetters } from "vuex";

const initForm = {
  service_id: null,
  description: "",
  status_id: null,
  service_frequency_id: null,
};
export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    ngoMap,
    formSelect,
    ClassModal,
    BButton,
    ServiceModal,
    formDatepicker,
    saveBtn,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BDropdown,
    BDropdownItem,
    BTooltip,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BFormRadio,
    BFormTextarea,
    BFormDatepicker,
    serviceCard,
  },
  data() {
    return {
      updateModal: false,
      serviceModal: false,
      updateServiceModal: false,
      editForm: {},
      selected_service: null,
      service_status: null,
      classId: 0,
      newClassModal: false,
      editClassModal: false,
      editClassForm: {},
    };
  },

  computed: {
    ...mapGetters("NgoProfile/NgoServices", [
      "servicesAndClassifications",
      "loading",
      "working",
    ]),
    ...mapGetters("NgoProfile", ["ngoData"]),

    statuses() {
      return this.$store.getters["NgoProfile/NgoServices/status"];
    },

    classificationTooltipText() {
      if (new Date(this.ngoData.decision_date).getFullYear() >= 2019) {
       return "فقط أربعة تصنيفات مسموحة على الأكثر";
      } else return "";
    },

    isClassificationAddDisabled() {
      // if (new Date(this.ngoData.decision_date).getFullYear() > 2019) {
      //   if (this.ngoData.legalForm.name_ar.includes("جمعية"))
      //     return this.servicesAndClassifications.length >= 1;
      //   else if (this.ngoData.legalForm.name_ar.includes("مؤسسة"))
      //     return this.servicesAndClassifications.length >= 2;
      //   else return true;
      // } else return false;
      if (new Date(this.ngoData.decision_date).getFullYear() > 2019) {
          return this.servicesAndClassifications.length >= 4;
      } else return false;
    },

    serviceFrequencies() {
      return this.$store.getters["NgoProfile/NgoServices/serviceFrequencies"];
    },
  },

  created() {
    this.fetchServicesAndClassifications();
    this.getStatus();
  },
  methods: {
    ...mapActions("NgoProfile/NgoServices", [
      "fetchServicesAndClassifications",
      "getStatus",
      "addServiceType",
      "addNewService",
      "addNewClassification",
      "updateService",
      "updateClassification",
      "deleteClassification",
    ]),
    openEditClassModal(classification) {
      this.editClassForm = JSON.parse(
        JSON.stringify({
          ngo_classification_id: classification.id,
          is_main: classification.classification_type,
        })
      );
      this.$refs.editClassModal.init(this.editClassForm);
      this.editClassModal = true;
    },
    onNewServiceType(opt) {
      this.addServiceType(opt).then(() => {
        this.$refs.serviceType.refreshOptions();
      });
    },
    checkStatus(e, val) {
      if (e) {
        this.editForm.status = val;
        this.editForm.status_id = val.id;
      }
    },
    showUpdateServiceModal(payload, classId) {
      this.classId = classId;
      this.editForm = JSON.parse(
        JSON.stringify({
          id: payload.id,
          classification_id: payload.service.classification_id,
          description: payload.description,
          service_frequency_id: payload.service_frequency_id,
          service_id: payload.service.id,
          status_id: payload.status.id,
          governorate_ids: payload.service.governorates.map((el) => el.id),
          category_ids: payload.service.ageCategories.map((el) => el.id),
        })
      );
      this.selected_service = { ...payload.service };
      this.updateServiceModal = true;
    },

    deleteClass(id) {
      this.$bvModal
        .msgBoxConfirm("سيتم حذف جميع الخدمات المرتبطة بهذا التصنيف.", {
          title: "هل أنت متأكد من حذف التصنيف ؟",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) this.deleteClassification(id);
        });
    },

    async saveService(form) {
      if (form.id) {
        await this.updateService(form).then(() => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "رسالة نجاح",
                icon: "InfoIcon",
                text: "تم تعديل البيانات بنجاح",
                variant: "primary",
              },
            },
            {
              position: "top-right",
            }
          );
        });
      } else {
        await this.addNewService(form);
      }
      this.serviceModal = false;
      this.updateServiceModal = false;
    },
    saveClassification(form) {
      {
        this.addNewClassification(form).then(() => {
          this.newClassModal = false;

          // this.$toast(
          //   {
          //     component: ToastificationContent,
          //     props: {
          //       title: "رسالة نجاح",
          //       icon: "InfoIcon",
          //       text: "تم تعديل البيانات بنجاح",
          //       variant: "primary",
          //     },
          //   },
          //   {
          //     position: "top-right",
          //   }
          // );
        });
      }
    },
    onUpdateClassification(form) {
      this.updateClassification({ ...form, id: this.classId }).then(() => {
        this.updateServiceModal = false;

        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "رسالة نجاح",
              icon: "InfoIcon",
              text: "تم تعديل البيانات بنجاح",
              variant: "primary",
            },
          },
          {
            position: "top-right",
          }
        );
      });
    },
  },
};
</script>

<style lang="scss">
::v-deep {
  .modal-title {
    color: var(--light);
  }
}
</style>
